import {get, post} from './request'
var baseUrl
// 环境变量
if (process.env.NODE_ENV === 'development') {
  baseUrl = '/api'
} else if (process.env.NODE_ENV === 'production') {
  baseUrl = 'https://ding-talk-platform.belle.net.cn/api'
  // baseUrl = 'http://dingding-download.larkplus-test.belle.net.cn/api'
}
const Api = {
  checkUserInfo (params) {
    return post(`${baseUrl}/check/user/info`, params)
  },
  phoneUpdate(params){
    return post(`${baseUrl}/check/phone/update`,params)
  },
  getUserInfo(params){
    return get(`${baseUrl}/check/user/get`,params)
  },
  getVerifyCode(params){
    return get(`${baseUrl}/check/verifyCode/send`,params)
  },
  checkVerifyCode(params){
    return post(`${baseUrl}/check/verifyCode/check`,params)
  }
}
export default Api



// WEBPACK FOOTER //
// ./src/request/api.js